import { useState } from 'react';
import { useContent } from 'src/contexts/ContentContext';
import { useUserHasTagTypePermissions } from 'src/hooks/useUserHasTagTypePermissions';
import { EditIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './TagsFormBody.css';
import { TagsFormBodyProps } from './TagsFormBody.types';
import { TagsPanelDisplayMode } from './TagsFormBodyV2/TagsPanelDisplayMode';
import { TagsPanelEditMode } from './TagsFormBodyV2/TagsPanelEditMode';
import { useTagsFormBody } from './useTagsFormBody';

export const TagsFormBodyV2 = ({
  disabled,
  tagsCurrentEntity,
  onTagsUpdate,
  entityType,
  canEditTags,
}: TagsFormBodyProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const editTagTypesLabel = useContent(ContentId.EditTagTypes);

  const { hasCreateTagTypePermission, hasEditTagTypePermission } =
    useUserHasTagTypePermissions(entityType);

  const {
    tagsWithEmptyValue,
    tagsWithValue,
    onTagsUpdateHandler,
    onTagValueChange,
  } = useTagsFormBody(entityType, tagsCurrentEntity, onTagsUpdate);

  return (
    <>
      <div className={styles.mainContent}>
        <div className={styles.editIconContainer}>
          <EditIcon
            disabled={disabled || isEditMode || !hasCreateTagTypePermission}
            fill={IconsFill.textBrand}
            onClick={() => {
              setIsEditMode(true);
            }}
            withHoverEffect
            title={editTagTypesLabel}
          />
        </div>
        {isEditMode ? (
          <TagsPanelEditMode
            tagsWithEmptyValue={tagsWithEmptyValue}
            tagsWithValue={tagsWithValue}
            onTagsUpdate={onTagsUpdateHandler}
            onTagValueChange={onTagValueChange}
            disabled={disabled || !hasEditTagTypePermission}
            onEditDone={() => {
              setIsEditMode(false);
            }}
            entityType={entityType}
          />
        ) : (
          <TagsPanelDisplayMode
            tagsWithEmptyValue={tagsWithEmptyValue}
            tagsWithValue={tagsWithValue}
            onTagsUpdate={onTagsUpdateHandler}
            onTagValueChange={onTagValueChange}
            disabled={disabled || !canEditTags}
            entityType={entityType}
          />
        )}
      </div>
    </>
  );
};
